import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SimilarProduct from "./SimilarProduct";
import Container from "react-bootstrap/Container";

function SimilarProductList({ cards }) {
	return (
		<Container fluid>
			<Row>
				{cards.map((product) => (
					<Col
						key={product.id}
						xs={6}
						sm={4}
						md={3}
						lg={3}
						xl={2}
						xxl={2}
					>
						<SimilarProduct {...product} />
					</Col>
				))}
			</Row>
		</Container>
	);
}
export default SimilarProductList;
